import React, { useState } from "react";

interface PasswordGateProps {
  onSubmit: (password: string) => void;
  loading: boolean;
  error: string | null;
}

const PasswordGate: React.FC<PasswordGateProps> = ({
  onSubmit,
  loading,
  error,
}) => {
  const [password, setPassword] = useState("");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (password.trim()) {
      onSubmit(password);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-6">
      <div className="max-w-md w-full">
        <div className="bg-white rounded-lg shadow-lg p-8">
          <div className="text-center mb-8">
            <div className="text-6xl mb-4">🔐</div>
            <h2 className="text-2xl font-bold text-gray-900">
              Admin Access Required
            </h2>
            <p className="text-gray-600 mt-2">
              Enter the admin password to access the Dominant Gateway Monitoring
              system
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label
                htmlFor="password"
                className="block text-sm font-medium text-gray-700 mb-2"
              >
                Password
              </label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                placeholder="Enter admin password"
                disabled={loading}
                autoFocus
              />
            </div>

            {error && (
              <div className="bg-red-50 border border-red-200 rounded-md p-3">
                <p className="text-sm text-red-800">{error}</p>
              </div>
            )}

            <button
              type="submit"
              disabled={loading || !password.trim()}
              className="w-full px-4 py-2 bg-blue-600 text-white font-medium rounded-md hover:bg-blue-700 disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors"
            >
              {loading ? "Verifying..." : "Access Admin Panel"}
            </button>
          </form>

          {/* <div className="mt-6 text-center text-sm text-gray-500">
            <p>
              Password is stored in environment variable
              <br />
              <code className="bg-gray-100 px-2 py-1 rounded text-xs">
                DOMINANT_MONITORING_PASSWORD
              </code>
            </p>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default PasswordGate;
